// src/mocks/handlers/invoices.handlers.js
import * as data from '../data/invoices.demo';

export const limitCheck = async () => data.limitCheck;

export const handle = async (config) => {
    if (config.method === 'post') return { success: true, data: data.invoiceCreated };
    if (/\/invoices\/\d+$/.test(config.url)) return { success: true, data: data.invoiceDetail };
    return { success: true, data: data.invoiceList };
};

export const retry = async () => ({ success: true, message: 'Reintentado' });
export const getAudit = async () => ({ success: true, data: data.invoiceAudit });
export const getPdf = async () => ({ url: '' });
export const getQr = async () => ({ qrData: '' });
